import type { AppState, Payload } from 'store/state';

export function baseAction(state: AppState, payload: Payload): AppState {
	return { ...state, ...payload };
}
